import React, { Component } from "react";
import { ActionLayoutData, LayoutRow } from "./TableLayoutComponents";
import {
  PopoverBody,
  Badge,
  Progress,
  Popover as PopoverBs,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
import { isEmpty, inRange } from "lodash";
import UserIcon3 from "../../assets/user-image-plc/User_Icon_3.svg";
import { Popover } from "react-tiny-popover";
// import { BsArrowDownRightSquare, BsPerson, BiUserPlus } from "react-icons/bs";
import {
  BiUserPlus,
  BiMailSend,
  BiCopy,
  BiLogoSlack,
  BiLogoMicrosoftTeams,
} from "react-icons/bi";
import { toastContainer } from "../../utils/toast";
import { LuCalendarCheck } from "react-icons/lu";

import {
  isUserRemoved,
  privacyMap,
  action_table_columns_width,
  task_priority,
  constructGroupLinkedUsersText,
  profilePicValidityCheck,
  baseUrl,
} from "../../utils/constants";
import ReactTooltip from "react-tooltip";
import axios from "../../axios";
import * as url from "../../utils/url";
import If from "../../components/Shared/If";
import { BiLink, BiUnlink } from "react-icons/bi";
import moment from "moment";
import PriorityContainer from "../../components/PriorityContainer/PriorityContainer";
import { isMobile } from "../../utils/deviceInfo";
import { toDateObject } from "react-multi-date-picker";
import ShareEntity from "../../components/ShareEntity/ShareEntity";
import slackLogo from "../../assets/icons/Slack-Small.png";
import teamsLogo from "../../assets/icons/Teams-Small.png";
import SlackSharePopup from "../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../components/SlackAndTeamsPopups/TeamsSharePopup";
import TurndownService from "turndown";
import { gfm } from "turndown-plugin-gfm";
export class ActionTitle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      showSlackShare: false,
      showTeamsShare: false,
      archiveActionModal: {
        display: false,
        item: null,
        type: "",
      },
    };
  }

  handleShareStore = (method, type) => {
    let onModel = "Task";
    const item = this.props.todo;
    let payload = {
      shareMethod: method,
      shareType: type,
      itemId: item._id,
      itemModel: onModel,
    };

    axios
      .post(url.storeShareLogs, payload)
      .then((data) => {
        console.log("stored_shared", data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleSocialShare = (data) => {
    return new Promise((resolve, reject) => {
      let finalString = this.getTextFormat();

      if (data.type === "SLACK") {
        finalString = finalString
          .replaceAll("<b>", "")
          .replaceAll("</b>", "")
          .replaceAll("<strong>", "")
          .replaceAll("</strong>", "");
      }

      let payload = {
        storyText: finalString,
        attachmentsText: "",
        user: {
          username: data.isAnonymous
            ? "Anonymous"
            : `${this.props.user.profile.firstName} ${this.props.user.profile.lastName}`,
          text: "",
        },
        entityType: "ACTION",
        channelId: data.channelId,
        channelName: data.channelName,
        type: data.type,
        workSpaceId: data.workSpaceId,
        teamId: data.teamId,
        tenantId: data.tenantId,
      };

      axios
        .post(url.shareStoryPost, payload)
        .then(({ data }) => {
          // console.log("data shared----", data);
          resolve(payload.channelId);
          const method = payload.type === "SLACK" ? 2 : 3;
          this.handleShareStore(method, payload.channelName);
          toastContainer("Shared successfully", "success");
        })
        .catch((error) => {
          let message = "Error occured while sending message";
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message === "channel_not_found"
          ) {
            message =
              "Dani is not added as a member to this channel , Please Add Dani as a member to this channel to Post a message";
          }
          toastContainer(message, "error");
          reject(message);
        });
    });
  };

  getTextFormat = () => {
    const { todo } = this.props;
    const linkedEOName = !isEmpty(todo.parentTask)
      ? todo.parentTaskTitle ||
        (!isEmpty(todo.parentTask.item) ? todo.parentTask.item.title : "")
      : "No Objective";

    const item = {
      _id: todo._id,
      description: todo.description,
      assigneeName: this.getAssigneeName(todo),
      dueDate: todo.dueDate
        ? moment(todo.dueDate).format("MMM D, YYYY")
        : "On-Going",
      title: todo.title,
      progress:
        this.checkProgressBarValue(todo) == 0
          ? "Not Started"
          : inRange(this.checkProgressBarValue(todo), 0, 99.99)
          ? `${this.checkProgressBarValue(todo)}%`
          : "Completed",
      status: this.isDueDatePast(todo)
        ? "Overdue"
        : !todo.isDeleted
        ? "Active"
        : "Archived",
      objectiveName: linkedEOName,
      priority: task_priority(todo.priority),
      privacy: privacyMap[todo.privacy],
      createdByName: todo.userId
        ? todo.userId.firstName + " " + todo.userId.lastName
        : "No name",
      createdOn: moment(todo.createdOn).format("MMM D, YYYY"),
    };

    let finalString = `<div>
     <div>
        <ul>
        {{middle_string}}
        </ul>
     </div>
     </div>`;

    let middle_string = "";

    if (item.title) {
      middle_string += `<li> Title:  ${item.title}</li>`;
    }
    if (item.assigneeName) {
      middle_string += `<li> Assignee:  ${item.assigneeName}</li>`;
    }

    if (item.dueDate) {
      middle_string += `<li> Due Date:  ${item.dueDate}</li>`;
    }

    if (item.progress) {
      middle_string += `<li> Progress:  ${item.progress}</li>`;
    }

    if (item.status) {
      middle_string += `<li> Status:  ${item.status}</li>`;
    }

    if (item.objectiveName) {
      middle_string += `<li> Objective Name:  ${item.objectiveName}</li>`;
    }

    if (item.priority) {
      middle_string += `<li> Priority:  ${item.priority}</li>`;
    }

    if (item.privacy) {
      middle_string += `<li> Privacy:  ${item.privacy}</li>`;
    }

    if (item.createdByName) {
      middle_string += `<li> Created By:  ${item.createdByName}</li>`;
    }

    if (item.createdOn) {
      middle_string += `<li> Created On:  ${item.createdOn}</li>`;
    }

    if (item.description && item.description.length) {
      middle_string += `<li> Description :${item.description.slice(3)} </li>`;
    }

    if (item._id) {
      middle_string += `<li> Task Url  : ${baseUrl()}home/planning/${
        item._id
      } </li>`;
    }
    finalString = finalString.replace("{{middle_string}}", middle_string);

    return finalString;
  };

  createEmailTxt = () => {
    let text = this.getTextFormat();

    text = text
      .replaceAll("<b>", "")
      .replaceAll("</b>", "")
      .replaceAll("<strong>", "")
      .replaceAll("</strong>", "");

    text = new TurndownService().use(gfm).turndown(text);

    return text;
  };

  showSelectSlackchannels = () => {
    this.setState({
      showSlackShare: true,
      dropdownOpen: !this.state.dropdownOpen,
    });
  };
  showSelectTeamschannels = () => {
    this.setState({
      showTeamsShare: true,
      dropdownOpen: !this.state.dropdownOpen,
    });
  };

  isDueDatePast = (todo) => {
    if (
      // todo.isDeleted != true &&
      !todo.completedDate &&
      todo.dueDate &&
      todo.dueDate != null &&
      todo.dueDate != undefined &&
      moment(todo.dueDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")
    ) {
      return true;
    }
    return false;
  };

  checkProgressBarValue = (task) => {
    let res;
    if (
      task.percentComplete &&
      task.percentComplete.length > 0 &&
      task.percentComplete[0].value
    ) {
      res = task.percentComplete[0].value;
    } else if (
      task.incompleteDate &&
      new Date(task.incompleteDate).valueOf() != NaN
    ) {
      res = 0;
    } else if (
      task.completedDate &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      res = 100;
    } else if (
      task.incompleteDate &&
      task.completedDate &&
      new Date(task.incompleteDate).valueOf() != NaN &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      if (task.completedDate > task.incompleteDate) {
        res = 100;
      } else {
        res = 0;
      }
    } else {
      res = 0;
    }
    return res;
  };

  getAssigneeName = (task) => {
    if (
      task &&
      task.assignedTo &&
      (task.assignedTo.firstName || task.assignedTo._id)
    ) {
      let assignedUser =
        task.assignedTo && task.assignedTo.firstName
          ? task.assignedTo
          : task.assignedToDoc
          ? task.assignedToDoc
          : false;

      let assignedUserFullName = assignedUser.lastName
        ? assignedUser.firstName + " " + assignedUser.lastName
        : assignedUser.firstName
        ? assignedUser.firstName
        : "";
      let { profile } = this.props.user;
      let taskOwner = isUserRemoved(task.userId)
        ? "Inactive User"
        : task.userId._id.toString() == profile._id.toString()
        ? profile
        : task.userId;

      assignedUserFullName = isUserRemoved(task.assignedTo)
        ? "Inactive User"
        : assignedUserFullName;

      return assignedUserFullName;
    } else {
      return "None";
    }
  };

  viewAction = (item) => {
    if (item.type == "action") {
      this.props.history.push(`/home/planning/${item._id}`);
    } else {
      this.props.history.push(`/home/enterprise-associatedActions/${item._id}`);
    }
  };

  handleColWidth = (col, mobile) => {
    let m_val = mobile ? "m" : "nm";
    let { actionColumnShown } = this.props;
    return action_table_columns_width(actionColumnShown, col, m_val);
  };

  toggle = () => {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  };

  isAssignee = (task) => {
    const { profile } = this.props.user;
    if (task && task.assignedTo && task.assignedTo._id) {
      if (profile._id === task.assignedTo._id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  isCreator = (task) => {
    const { profile } = this.props.user;
    if (task && task.userId && task.userId._id) {
      if (profile._id === task.userId._id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  handleArchiveModal = (type, item) => {
    this.setState({
      archiveActionModal: {
        display: true,
        item,
        type,
      },
      dropdownOpen: false,
    });
  };

  render() {
    const {
      todo,
      currentUser,
      titleCol,
      titleColMobile,
      plainTable,
      noEdit,
      parentActionId,
      tableType,
    } = this.props;

    const { showSlackShare, showTeamsShare, archiveActionModal } = this.state;

    const { orgAdmin } = this.props.user.profile;

    const canRemoveSubAction = this.props.isParentTaskPublic
      ? this.isAssignee(todo) || this.isCreator(todo) || orgAdmin
      : this.isAssignee(todo) || this.isCreator(todo) || orgAdmin;

    const linkedEOName = !isEmpty(todo.parentTask)
      ? todo.parentTaskTitle ||
        (!isEmpty(todo.parentTask.item) ? todo.parentTask.item.title : "")
      : "No Objective";

    const teamsEnabled =
      this.props.user.profile.organizationId &&
      this.props.user.profile.organizationId.allowedTeamsTenants
        ? this.props.user.profile.organizationId.allowedTeamsTenants.length > 0
        : false;
    const slackEnabled =
      this.props.user.profile.organizationId &&
      this.props.user.profile.organizationId.allowedSlackWorkspaces
        ? this.props.user.profile.organizationId.allowedSlackWorkspaces.length >
          0
        : false;

    const popOverUi = (
      <PopoverBody className={"bg-dark popover-items"}>
        <div
          className="chart-list-dropdown-options"
          style={{ display: "flex" }}
          onClick={() => {
            if (noEdit) {
              this.viewAction(todo);
            } else {
              this.props.viewEditTask(todo);
            }

            this.toggle();
          }}
        >
          <i className="story-item flaticon-vision"></i>
          <span className="chart-list-dropdown-options-text">View / Edit</span>
        </div>
        {!noEdit && tableType !== "subAction" && (
          <span>
            {todo.assignedTo == null ||
            (todo.assignedTo && currentUser._id !== todo.assignedTo._id) ||
            todo.userId._id.toString() == currentUser._id.toString() ? (
              todo.isDeleted != true ? (
                <div
                  className="chart-list-dropdown-options"
                  style={{ display: "flex" }}
                  onClick={() => {
                    this.handleArchiveModal("ARCHIVE", todo);

                    // this.props.handleDeleteTodo(todo)
                  }}
                >
                  <i className="chart-item-menu flaticon-trash mr-2"></i>
                  <span className="chart-list-dropdown-options-text">
                    Archive
                  </span>
                </div>
              ) : (
                <div
                  className="chart-list-dropdown-options"
                  style={{ display: "flex" }}
                  onClick={() => {
                    this.handleArchiveModal("RESTORE", todo);
                    // this.props.handleUnDeleteTodo(todo)
                  }}
                >
                  <i className="chart-item-menu flaticon-update mr-2"></i>
                  <span className="chart-list-dropdown-options-text">
                    Restore Action
                  </span>
                </div>
              )
            ) : null}
          </span>
        )}

        {this.props.handleRemoveGroupUI && this.props.handleRemoveGroupUI(todo)}

        {tableType === "subAction" && canRemoveSubAction && (
          <div
            className="chart-list-dropdown-options"
            style={{ display: "flex" }}
            onClick={() => {
              this.toggle();
              const pTaskId =
                todo.parentTask && todo.parentTask.item
                  ? todo.parentTask.item._id || todo.parentTask.item
                  : "";
              this.props.handleSubActionUnlink(todo.type, todo._id, pTaskId);
            }}
          >
            <i className="chart-item-menu flaticon-trash mr-2"></i>
            <span className="chart-list-dropdown-options-text">
              Remove subaction
            </span>
          </div>
        )}

        <div
          className={
            slackEnabled
              ? "chart-list-dropdown-options"
              : "chart-list-dropdown-options-disable"
          }
          onClick={() => (slackEnabled ? this.showSelectSlackchannels() : null)}
        >
          <BiLogoSlack size={19} />
          <span
            className={
              slackEnabled
                ? "chart-list-dropdown-options-text"
                : "chart-list-dropdown-options-text-disable"
            }
          >
            {" "}
            {slackEnabled ? "Share To Slack" : "Slack not enabled"}
          </span>
        </div>

        <div
          className={
            teamsEnabled
              ? "chart-list-dropdown-options"
              : "chart-list-dropdown-options-disable"
          }
          onClick={() => (teamsEnabled ? this.showSelectTeamschannels() : null)}
        >
          <BiLogoMicrosoftTeams size={19} />
          <span
            className={
              teamsEnabled
                ? "chart-list-dropdown-options-text"
                : "chart-list-dropdown-options-text-disable"
            }
          >
            {" "}
            {teamsEnabled ? "Share To Teams" : "Teams not enabled"}
          </span>
        </div>

        <div
          className="chart-list-dropdown-options"
          onClick={() => {
            this.handleShareStore(1, "NORMAL_EMAIL");
            window.open(
              `mailto:someone@yoursite.com?subject=${"Planning Action Share"}&body=${encodeURIComponent(
                this.createEmailTxt()
              )}`
            );
          }}
        >
          <BiMailSend size={"18px"} className="" />{" "}
          <span className="chart-list-dropdown-options-text">
            Share To Email
          </span>
        </div>
        <div
          className="chart-list-dropdown-options"
          onClick={() => {
            this.handleShareStore(1, "GMAIL");
            window.open(
              `https://mail.google.com/mail/u/0/?fs=1&to=&su=${"Planning Action Share"}&body=${encodeURIComponent(
                this.createEmailTxt()
              )}&tf=cm`
            );
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            fill="currentColor"
            viewBox="0 0 16 22"
            className="mr-1"
          >
            <path d="M15.545 6.558a9.42 9.42 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.689 7.689 0 0 1 5.352 2.082l-2.284 2.284A4.347 4.347 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.792 4.792 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.702 3.702 0 0 0 1.599-2.431H8v-3.08h7.545z" />
          </svg>
          <span className="chart-list-dropdown-options-text">
            Share Via Gmail{" "}
          </span>
        </div>

        <div
          className="chart-list-dropdown-options"
          onClick={() => {
            this.handleShareStore(0, "COPY");
            navigator.clipboard.writeText(this.createEmailTxt());
            toastContainer("Copied successfully", "success");
          }}
        >
          <BiCopy className="mr-1" size={"19px"} color="white" />
          <span className="chart-list-dropdown-options-text"> Copy </span>
        </div>
      </PopoverBody>
    );

    return (
      <ActionLayoutData
        colWidth={this.handleColWidth("actionTitle", false)}
        colWidthMobile={12}
        plainTable={plainTable}
        fullWidth
        // className="d-table_cell"
      >
        {archiveActionModal &&
        archiveActionModal.display &&
        archiveActionModal.item ? (
          <Modal
            isOpen={true}
            className={`dashboardArchiveModalContainer createModalContainer ${
              archiveActionModal.type === "ARCHIVE" ? "" : "SuccessHead"
            }`}
          >
            <ModalHeader className="dashboardHeader">
              <div className="dashboardModalTitle">
                {archiveActionModal.type === "ARCHIVE" ? "Archive" : "Restore"}{" "}
                action
              </div>
            </ModalHeader>
            <ModalBody style={{ padding: "30px" }}>
              <div className="singleTaskModalBody">
                Are you sure you wish to continue with this action ?
              </div>

              <div
                className="singleTaskModalBtn"
                style={{ padding: "10px 0px 0px 0px" }}
              >
                <Button
                  className={`profile-modal-save-btn ${
                    archiveActionModal.type === "ARCHIVE"
                      ? "Archive"
                      : "Restore"
                  } } weeklyWinBtn`}
                  onClick={() => {
                    if (archiveActionModal.type === "ARCHIVE") {
                      this.props.handleDeleteTodo(archiveActionModal.item);
                    } else {
                      this.props.handleUnDeleteTodo(archiveActionModal.item);
                    }
                  }}
                  // disabled={!this.state.isEnterpriseObjectiveSelected}
                >
                  <span className="profile-modal-save-btn-txt">
                    {archiveActionModal.type === "ARCHIVE"
                      ? "Archive"
                      : "Restore"}
                    <span className="ml10 flaticon-tick"></span>
                  </span>
                </Button>

                <Button
                  className="profile-modal-cancel-btn float-right weeklyWinBtn"
                  onClick={() =>
                    this.setState({
                      archiveActionModal: {
                        display: false,
                        item: null,
                        type: "",
                      },
                    })
                  }
                >
                  <span className="profile-modal-cancel-btn-txt">Cancel</span>
                </Button>
              </div>
            </ModalBody>
          </Modal>
        ) : (
          ""
        )}

        <div className="name-action-container">
          {this.props.isModal ? (
            <Popover
              positions={["right", "bottom"]}
              containerStyle={{
                marginLeft: "10px",
                zIndex: "99999",
                marginTop: "30px",
              }}
              isOpen={this.state.dropdownOpen}
              onClickOutside={() => this.toggle(todo._id)}
              className={
                tableType == "subAction"
                  ? "parent-nested-subaction-popover"
                  : ""
              }
              content={() => popOverUi}
            >
              <i
                className="chart-item-menu flaticon-menu-1"
                style={{ cursor: "pointer" }}
                onClick={() => this.toggle(todo._id)}
                id={`Popover1${todo._id}`}
              ></i>
            </Popover>
          ) : (
            <span>
              <i
                className="chart-item-menu flaticon-menu-1"
                style={{ cursor: "pointer" }}
                onClick={() => this.toggle(todo._id)}
                id={`Popover1${todo._id}`}
              ></i>
              <PopoverBs
                target={`Popover1${todo._id}`}
                placement="left-end"
                isOpen={this.state.dropdownOpen}
                toggle={() => this.toggle(todo._id)}
              >
                {popOverUi}
              </PopoverBs>
            </span>
          )}

          <div
            data-tip={todo.title}
            className="todo-item-title font-weight-bold cursor-pointer"
            onClick={() => this.props.viewEditTask(todo)}
          >
            {todo.title && !isEmpty(todo.title) ? todo.title : "NA"}
          </div>
          {/* {this.props.handleRemoveGroupUI && (
            <div className="action-linked-by">{constructGroupLinkedUsersText(todo)}</div>
          )} */}
        </div>

        {showSlackShare && (
          <SlackSharePopup
            handleSocialShare={this.handleSocialShare}
            slackShared={[]}
            answer={""}
            orgId={this.props.user.profile.organizationId._id}
            userId={this.props.user.profile._id}
            setShowSlackPopup={(val) => this.setState({ showSlackShare: val })}
            organization={this.props.user.profile.organizationId}
          />
        )}
        {showTeamsShare && (
          <TeamsSharePopup
            handleSocialShare={this.handleSocialShare}
            teamsShared={[]}
            answer={""}
            orgId={this.props.user.profile.organizationId._id}
            userId={this.props.user.profile._id}
            setShowTeamsPopup={(val) => this.setState({ showTeamsShare: val })}
            organization={this.props.user.profile.organizationId}
          />
        )}
      </ActionLayoutData>
    );
  }
}
export default class ActionRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      priority: props.todo.priority,
      archiveActionModal: {
        display: false,
        item: null,
        type: "",
      },
    };
  }

  handleColWidth = (col, mobile) => {
    let m_val = mobile ? "m" : "nm";
    let { actionColumnShown } = this.props;
    return action_table_columns_width(actionColumnShown, col, m_val);
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.todo.priority !== nextProps.todo.priority) {
      if (this.state.priority !== nextProps.priority) {
        this.setState({ priority: nextProps.todo.priority });
      }
    }
  }

  checkProgressBarValue = (task) => {
    let res;
    if (
      task.percentComplete &&
      task.percentComplete.length > 0 &&
      task.percentComplete[0].value
    ) {
      res = task.percentComplete[0].value;
    } else if (
      task.incompleteDate &&
      new Date(task.incompleteDate).valueOf() != NaN
    ) {
      res = 0;
    } else if (
      task.completedDate &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      res = 100;
    } else if (
      task.incompleteDate &&
      task.completedDate &&
      new Date(task.incompleteDate).valueOf() != NaN &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      if (task.completedDate > task.incompleteDate) {
        res = 100;
      } else {
        res = 0;
      }
    } else {
      res = 0;
    }
    return res;
  };

  isAssignee = (task) => {
    const { profile } = this.props.user;
    if (task && task.assignedTo && task.assignedTo._id) {
      if (profile._id === task.assignedTo._id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  isCreator = (task) => {
    const { profile } = this.props.user;
    if (task && task.userId && task.userId._id) {
      if (profile._id === task.userId._id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  assignedUserCheck = (task) => {
    if (
      task &&
      task.assignedTo &&
      (task.assignedTo.firstName || task.assignedTo._id)
    ) {
      let assignedUser =
        task.assignedTo && task.assignedTo.firstName
          ? task.assignedTo
          : task.assignedToDoc
          ? task.assignedToDoc
          : false;

      let assignedUserFullName = assignedUser.lastName
        ? assignedUser.firstName + " " + assignedUser.lastName
        : assignedUser.firstName
        ? assignedUser.firstName
        : "";
      let { profile } = this.props.user;
      let taskOwner = isUserRemoved(task.userId)
        ? "Inactive User"
        : task.userId._id.toString() == profile._id.toString()
        ? profile
        : task.userId;

      assignedUserFullName = isUserRemoved(task.assignedTo)
        ? "Inactive User"
        : assignedUserFullName;
      return (
        <div className="" data-tip={assignedUserFullName}>
          {profilePicValidityCheck(assignedUser.profilePic) ? (
            <img
              src={assignedUser.profilePic || UserIcon3}
              height="26px"
              width="26px"
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <span
              className="spotlightUserInitials"
              style={{ width: "30px" }}
              data-letters={this.getInitials(assignedUser)}
            ></span>
          )}
          <ReactTooltip />
        </div>
      );
    } else {
      return (
        <span className="assign-border-wrapper">
          <BiUserPlus size={"25px"} />
        </span>
      );
      // <BsPerson size={"25px"} className="actionsNoAssignee" />;
    }
  };

  taskOwnerCheck = (task) => {
    if (task && task.userId && (task.userId.firstName || task.userId._id)) {
      let taskOwner =
        task.userId && task.userId.firstName ? task.userId : false;

      let taskOwnerFullName = taskOwner.lastName
        ? taskOwner.firstName + " " + taskOwner.lastName
        : taskOwner.firstName
        ? taskOwner.firstName
        : "";
      let { profile } = this.props.user;
      let taskOwnerRemoved = isUserRemoved(task.userId)
        ? "Inactive User"
        : task.userId._id.toString() == profile._id.toString()
        ? profile
        : task.userId;

      taskOwnerFullName = isUserRemoved(task.userId)
        ? "Inactive User"
        : taskOwnerFullName;
      return (
        <div className="" data-tip={taskOwnerFullName}>
          {profilePicValidityCheck(taskOwner.profilePic) ? (
            <img
              src={taskOwner.profilePic || UserIcon3}
              height="26px"
              width="26px"
              style={{ borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <span
              className="spotlightUserInitials"
              style={{ width: "30px" }}
              data-letters={this.getInitials(taskOwner)}
            ></span>
          )}
          <ReactTooltip />
        </div>
      );
    } else {
      return (
        <span className="assign-border-wrapper">
          <BiUserPlus size={"25px"} />
        </span>
      );
      // <BsPerson size={"25px"} className="actionsNoAssignee" />;
    }
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  toggleActionsLink = (todo) => {
    const actionType = !isEmpty(todo.parentTask) ? "unlink" : "link";
    actionType == "link"
      ? this.props.getEOList(todo)
      : this.props.unlinkEO(todo);
  };

  isDueDatePast = (todo) => {
    if (
      // todo.isDeleted != true &&
      !todo.completedDate &&
      todo.dueDate &&
      todo.dueDate != null &&
      todo.dueDate != undefined &&
      moment(todo.dueDate).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")
    ) {
      return true;
    }
    return false;
  };

  handlePriorityChange = (task) => {
    // axios
    //   .post(url.editTodo, {
    //     taskUpdate: { ...task },
    //     updatedFields: ["priority"],
    //   })
    //   .then(({ data }) => {
    //     const newTask = data.data;
    //     this.props.handleUpdateInTable(newTask);
    //   })
    //   .catch(err => console.log(err));
  };

  getDuedateText = (dueDate) => {
    const days = moment().diff(dueDate, "days") + 1;

    if (days > 7 && days <= 30) {
      return `${Math.floor(days / 7)} ${
        Math.floor(days / 7) > 1 ? "weeks" : "week"
      } past`;
    } else if (days > 30 && days <= 365) {
      return `${Math.floor(days / 30)} ${
        Math.floor(days / 30) > 1 ? "months" : "month"
      } past`;
    } else if (days > 365) {
      return `${Math.floor(days / 365)} ${
        Math.floor(days / 365) > 1 ? "years" : "year"
      } past`;
    } else {
      return `${days} ${days > 1 ? "days" : "day"}  past`;
    }
  };

  renderPrivacyStatus = (task) => {
    if (
      task &&
      task.parentTask &&
      task.parentTask.item &&
     
      (task.privacy == 2 ||
        task.privacy == 1 ||
        task.privacy == null ||
        task.privacy == undefined ||
        task.privacy == "PUBLIC" ||
        !task.hasOwnProperty("privacy"))
    ) {

      if( task.type != "subAction"){
        return (
          <Badge className={"badge-small-text pill-badge-assigned"} pill={true}>
            Linked
          </Badge>
        );
      }else{
        return <Badge className={"badge-small-text pill-badge-public"} pill={true}>
        {privacyMap[1]}
      </Badge>
      }
    
    }
    if (task.privacy === 0) {
      if (
        task &&
        task.assignedTo &&
        (task.assignedTo.firstName || task.assignedTo._id)
      ) {
        let assignedUser =
          task.assignedTo && task.assignedTo.firstName
            ? task.assignedTo
            : task.assignedToDoc
            ? task.assignedToDoc
            : false;

        let { profile } = this.props.user;

        if (assignedUser._id.toString() === profile._id.toString()) {
          return (
            <Badge
              className={"badge-small-text pill-badge-assigned"}
              pill={true}
            >
              Assigned
            </Badge>
          );
        } else {
          return (
            <Badge
              className={"badge-small-text pill-badge-private"}
              pill={true}
            >
              Private
            </Badge>
          );
        }
      } else {
        return (
          <Badge className={"badge-small-text pill-badge-private"} pill={true}>
            {privacyMap[0]}
          </Badge>
        );
      }
    } else {

      if(task.privacy == 1){
         return (
          <Badge className={"badge-small-text pill-badge-public"} pill={true}>
            {privacyMap[1]}
          </Badge>
        );
      }else{
        return (
          <Badge className={"badge-small-text pill-badge-public"} pill={true}>
            {privacyMap[task.privacy]}
          </Badge>
        );
      }
      
    }
  };

  renderTaskStatus = (task) => {
    if (!task.dueDate && !task.completedDate) {
      return (
        <Badge pill color="primary" className={"badge-small-text"}>
          On-going
        </Badge>
      );
    }
    if (this.isDueDatePast(task)) {
      return (
        <Badge pill className={"badge-small-text overdue-btn-pl"}>
          Overdue
        </Badge>
      );
    }

    if (task.completedDate) {
      if (
        moment(task.completedDate).format("YYYY-MM-DD") <=
          moment(task.dueDate).format("YYYY-MM-DD") ||
        moment(task.completedDate).format("YYYY-MM-DD") >
          moment(task.dueDate).format("YYYY-MM-DD")
      ) {
        return (
          <Badge pill color="success" className={"badge-small-text"}>
            Complete
          </Badge>
        );
      }
    }

    if (
      task.dueDate &&
      moment(task.dueDate).format("YYYY-MM-DD") >=
        moment().format("YYYY-MM-DD") &&
      !task.completedDate
    ) {
      return (
        <Badge pill color="warning" className={"badge-small-text text-white"}>
          Not Due
        </Badge>
      );
    }
  };

  render() {
    const { todo, currentUser, plainTable } = this.props;

    const { archiveActionModal } = this.state;

    todo.parentTask =
      todo.parentTask && todo.parentTask.item ? todo.parentTask : null;

    const linkedEOName =
      todo.parentTask && !isEmpty(todo.parentTask.item)
        ? todo.parentTaskTitle ||
          (!isEmpty(todo.parentTask.item) ? todo.parentTask.item.title : "Link")
        : "Link";

    if (this.props.showTitleOnly) {
      return (
        <ActionTitle
          parentActionId={this.props.parentActionId}
          tableType={this.props.tableType}
          isParentTaskPublic={this.props.isParentTaskPublic}
          handleSubActionUnlink={this.props.handleSubActionUnlink}
          noEdit={this.props.noEdit}
          colWidth={this.handleColWidth("actionTitle", isMobile)}
          colWidthMobile={this.handleColWidth("actionTitle", isMobile)}
          {...this.props}
        />
      );
    }

    let { actionColumnShown, noEdit } = this.props;

    return (
      <LayoutRow
        className={`pl-tasks-row row-scroll-width`}
        plainTable={plainTable}
        style={{ width: `${this.props.totalColsCounter * 122}px` }}
      >
        {!this.props.hideTitle && (
          <ActionTitle
            parentActionId={this.props.parentActionId}
            tableType={this.props.tableType}
            isParentTaskPublic={this.props.isParentTaskPublic}
            handleSubActionUnlink={this.props.handleSubActionUnlink}
            noEdit={this.props.noEdit}
            plainTable={plainTable}
            colWidth={this.handleColWidth("actionTitle", isMobile)}
            colWidthMobile={this.handleColWidth("actionTitle", isMobile)}
            {...this.props}
          />
        )}
        {/* {JSON.stringify(archiveActionModal.display)} */}

        {actionColumnShown.map((e) => {
          if (e == "assignee") {
            return (
              <ActionLayoutData
                colWidth={this.handleColWidth("assignee", isMobile)}
                className="col-pl-0"
                colWidthMobile={this.handleColWidth("assignee", isMobile)}
                plainTable={plainTable}
                key={e + "_" + todo._id}
              >
                <div className="myActionsContainer-dark centerText">
                  {this.assignedUserCheck(todo)}
                </div>
              </ActionLayoutData>
            );
          }

          if (e == "taskCounter") {
            return (
              <ActionLayoutData
                colWidth={this.handleColWidth("taskCounter", isMobile)}
                className="col-pl-0"
                colWidthMobile={this.handleColWidth("taskCounter", isMobile)}
                plainTable={plainTable}
                key={e + "_" + todo._id}
              >
                <div
                  className="centerText"
                  style={{
                    color: "#252526b3",
                    fontSize: "15px",
                  }}
                >
                  {todo.taskCounter}
                </div>
              </ActionLayoutData>
            );
          }

          if (e === "type") {
            return (
              <ActionLayoutData
                plainTable={plainTable}
                colWidth={this.handleColWidth("type", isMobile)}
                colWidthMobile={this.handleColWidth("type", isMobile)}
                key={e + "_" + todo._id}
              >
                {todo.type == "action" ? (
                  <Badge pill className={"badge-small-text"} color="primary">
                    Action
                  </Badge>
                ) : (
                  <Badge pill className={"badge-small-text"} color="secondary">
                    Sub-Action
                  </Badge>
                )}
              </ActionLayoutData>
            );
          }

          if (e == "project") {
            return (
              <ActionLayoutData
                plainTable={plainTable}
                colWidth={this.handleColWidth("project", isMobile)}
                colWidthMobile={this.handleColWidth("project", isMobile)}
                key={e + "_" + todo._id}
              >
                <div className="link-unlink-wrapper">
                  {todo.isDeleted != true ? (
                    <If condition={isEmpty(todo.parentTask)}>
                      <div
                        className="userActionsLinkedItemContainer"
                        onClick={() => {
                          if (noEdit) {
                          } else {
                            this.toggleActionsLink(todo);
                          }
                        }}
                      >
                        {isEmpty(todo.parentTask) ? (
                          <div>
                            {!noEdit ? (
                              <span className="enterpriseName font-weight-bold">
                                <BiLink />
                                {linkedEOName}
                              </span>
                            ) : (
                              <span className="enterpriseName">
                                No objective linked
                              </span>
                            )}
                          </div>
                        ) : (
                          <span
                            data-tip={linkedEOName}
                            onClick={() =>
                              this.props.history.push(
                                `/home/enterprise-associatedActions/${todo.parentTask.item}`
                              )
                            }
                            className="enterpriseName"
                          >
                            {linkedEOName || "Anonymous objective"}
                          </span>
                        )}
                        <ReactTooltip />
                      </div>
                    </If>
                  ) : (
                    <div className="link-unlink-wrapper">
                      <span className="archived-text">
                        {" "}
                        {linkedEOName == "Link" ? "No Objective" : linkedEOName}
                      </span>
                    </div>
                  )}

                  <div className="d-flex">
                    <If condition={!isEmpty(todo.parentTask)}>
                      <div className="eoTitleContainer">
                        <span
                          data-tip={
                            todo.parentTaskArchived !== true
                              ? linkedEOName
                              : `${linkedEOName} ( Archived )`
                          }
                          onClick={
                            todo.parentTaskArchived !== true ||
                            currentUser.orgAdmin == true
                              ? () => {
                                  this.props.history.push(
                                    `/home/enterprise-associatedActions/${todo.parentTask.item}`
                                  );
                                }
                              : null
                          }
                          className={`enterpriseName ${
                            todo.parentTaskArchived !== true ||
                            currentUser.orgAdmin
                              ? ""
                              : "archived-text"
                          }`}
                        >
                          <span>
                            {todo.parentTaskArchived !== true
                              ? linkedEOName
                              : `${linkedEOName} ( Archived )`}
                          </span>
                        </span>
                        <span></span>
                        <ReactTooltip />
                      </div>
                    </If>
                    {/*<br />*/}
                    <If condition={!isEmpty(todo.parentTask)}>
                      {!noEdit && (
                        <div
                          className="text-center"
                          onClick={() => this.toggleActionsLink(todo)}
                        >
                          <span
                            className="enterpriseName ml-2 text-danger text-small font-weight-bold"
                            data-tip="Unlink"
                          >
                            <BiUnlink
                              size={"14px"}
                              className="font-weight-bold"
                            />{" "}
                            {this.props.isHidden ? "" : "Unlink action"}
                          </span>
                          <ReactTooltip />
                        </div>
                      )}
                    </If>
                  </div>
                </div>
              </ActionLayoutData>
            );
          }

          if (e == "dueDate") {
            return (
              <ActionLayoutData
                plainTable={plainTable}
                colWidth={this.handleColWidth("dueDate", isMobile)}
                colWidthMobile={this.handleColWidth("dueDate", isMobile)}
                key={e + "_" + todo._id}
              >
                {todo.dueDate ? (
                  <div
                    className={`myActionsContainer-dark ${
                      this.isDueDatePast(todo) ? "dueDatePastTxt" : ""
                    }`}
                    data-tip={this.getDuedateText(todo.dueDate)}
                  >
                    {moment(todo.dueDate).format("MMM D, YYYY")}

                    <ReactTooltip />
                  </div>
                ) : (
                  // <Badge
                  //   pill
                  //   className={"badge-small-text ongoing-css"}
                  //   color="success"
                  // >
                  //   On-going
                  // </Badge>
                  <div className="text-center">
                    <LuCalendarCheck size={23} color="gray" />
                  </div>
                )}{" "}
              </ActionLayoutData>
            );
          }

          if (e == "progress") {
            return (
              <ActionLayoutData
                colWidth={this.handleColWidth("progress", isMobile)}
                className="px-1"
                colWidthMobile={this.handleColWidth("progress", isMobile)}
                plainTable={plainTable}
                key={e + "_" + todo._id}
              >
                <div className="allTaskProgressContainer">
                  {this.checkProgressBarValue(todo) === 0 ? (
                    <Badge
                      pill
                      className={"badge-small-text"}
                      color="secondary"
                    >
                      Not started
                    </Badge>
                  ) : inRange(this.checkProgressBarValue(todo), 0, 99.99) ? (
                    <div className="d-flex align-items-center">
                      <Progress
                        cssModule={{
                          height: "10px",
                        }}
                        value={this.checkProgressBarValue(todo)}
                        className={
                          this.checkProgressBarValue(todo) == 100
                            ? "allTaskProgress progressCompleted"
                            : "allTaskProgress"
                        }
                      >
                        {" "}
                      </Progress>
                      <span className="ml-1 all-progress-text">
                        {this.checkProgressBarValue(todo)}%
                      </span>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center">
                      <Progress
                        cssModule={{
                          height: "10px",
                        }}
                        value={this.checkProgressBarValue(todo)}
                        className={
                          this.checkProgressBarValue(todo) == 100
                            ? "allTaskProgress progressCompleted"
                            : "allTaskProgress"
                        }
                      >
                        {" "}
                      </Progress>
                      <span className="ml-1 all-progress-text">
                        {this.checkProgressBarValue(todo)}%
                      </span>
                    </div>
                  )}
                </div>
              </ActionLayoutData>
            );
          }

          if (e == "status") {
            return (
              <ActionLayoutData
                plainTable={plainTable}
                colWidth={this.handleColWidth("status", isMobile)}
                colWidthMobile={this.handleColWidth("status", isMobile)}
                key={e + "_" + todo._id}
              >
                {/* {this.isDueDatePast(todo) ? (
                  <Badge pill className={"badge-small-text overdue-btn-pl"}>
                    Overdue
                  </Badge>
                ) : (
                  <Badge pill color="success" className={"badge-small-text"}>
                    Not Due
                  </Badge>
                )} */}

                {this.renderTaskStatus(todo)}

                {/* {todo.isDeleted != true ? (
                  <div className="">
                    <Badge pill className={"badge-small-text"} color="success">
                      Active
                    </Badge>
                  </div>
                ) : (
                  <div className="">
                    <Badge pill className={"badge-small-text"} color="warning">
                      Archived
                    </Badge>
                  </div>
                )} */}
              </ActionLayoutData>
            );
          }

          if (e == "priority") {
            return (
              <ActionLayoutData
                colWidth={this.handleColWidth("priority", isMobile)}
                colWidthMobile={this.handleColWidth("priority", isMobile)}
                plainTable={plainTable}
                key={e + "_" + todo._id}
              >
                <PriorityContainer
                  task={{ ...todo, priority: todo.priority || 0 }}
                  isActive={false}
                  size={"20px"}
                  handlePriorityChange={this.handlePriorityChange}
                />
              </ActionLayoutData>
            );
          }

          if (e == "createdBy") {
            return (
              <ActionLayoutData
                colWidth={this.handleColWidth("createdBy", isMobile)}
                colWidthMobile={this.handleColWidth("createdBy", isMobile)}
                plainTable={plainTable}
                key={e + "_" + todo._id}
              >
                <div className="myActionsContainer-dark centerText">
                  {this.taskOwnerCheck(todo)}
                </div>
              </ActionLayoutData>
            );
          }

          if (e == "privacyStatus") {
            return (
              <ActionLayoutData
                colWidth={this.handleColWidth("privacyStatus", isMobile)}
                colWidthMobile={this.handleColWidth("privacyStatus", isMobile)}
                plainTable={plainTable}
                key={e + "_" + todo._id}
              >
                {this.renderPrivacyStatus(todo)}
              </ActionLayoutData>
            );
          }
        })}
      </LayoutRow>
    );
  }
}
